import { Component, Input, Output, EventEmitter } from 'ng-metadata/core';
import './menu-subheader.component.scss';

/**
 * @ngdoc directive
 * @name mwMenuSubheader
 * @module mw.components.menu
 *
 * @param {string} [actionLabel] - If a label is specified, a clickable action label will be displayed in the subheader.
 * @param {expression} [on-action-click] - Angular expression to evaluate on click of the subheader action label. $event is the ng-click event.
 * @param {boolean} [md-prevent-menu-close] - Determine whether or not clicking on the action button causes the menu to close.
 *
 * @description
 * `<mw-menu-subheader>` provides a means for separating and describing groups of menu items.
 *
 * @usage
 * <hljs hljs-language="html">
 *   <!-- Standard Subheader -->
 *   <mw-menu-subheader>Standard Subheader</mw-menu-subheader>
 *
 *   <!-- Subheader w/ clickable Action Label -->
 *   <mw-menu-subheader action-label="Action" on-action-click="$ctrl.handleActionClick()">Subheader w/ Action</mw-menu-subheader>
 *
 * </hljs>
 *
 */
@Component({
    selector: 'mw-menu-subheader',
    template: `
        <md-subheader class="mw-menu-subheader md-no-sticky">
            <span>&nbsp;</span>
            <span class="mw-menu-subheader__label">
                <ng-transclude></ng-transclude>
            </span>
            <md-button class="mw-button mw-button--slim mw-menu-subheader__action-button md-no-focus" tabindex="-1" md-prevent-menu-close="$ctrl.mdPreventMenuClose" ng-show="$ctrl.actionLabel" ng-click="$ctrl.handleActionClick($event)" md-no-ink>{{$ctrl.actionLabel}}</md-button>
        </md-subheader>
    `,
    legacy: {
        transclude: true
    }
})
export class MenuSubheaderComponent {
    @Input('@') actionLabel: string;
    @Input('<') mdPreventMenuClose: boolean;
    @Output() onActionClick = new EventEmitter<ng.IAngularEvent>();

    constructor() {
        'ngInject';
    }

    handleActionClick(event: ng.IAngularEvent) {
        this.onActionClick.emit(event);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/menu/menu-subheader/menu-subheader.component.ts